import React, { FC } from 'react';
import { Badge, Divider } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import { useInsightsContainer } from 'components/insights/context';
import InsightLitePagePerformance from './InsightLitePagePerformance';
import InsightLitePostsPerformance from './InsightLitePostsPerformance';
import RequestNewMetricsCard from 'app/modules/insights/modules/pagePerformance/components/RequestNewMetricsCard';
import InitializationStatus from 'app/modules/insights/components/InitializationStatus';

type Props = {};

const InsightsLiteContent: FC<Props> = () => {
  const { t } = useTranslation();
  const { activeState, arePagesLoading } = useInsightsContainer();
  if (arePagesLoading) {
    return <InitializationStatus status="loading" />;
  }
  if (!activeState.page) {
    return (
      <InitializationStatus
        status="error"
        message={{
          main: t('insightsLite.noProfileSelected'),
          secondary: t('insightsLite.noProfileSelectedDescription'),
        }}
      />
    );
  }
  return (
    <>
      <section className="tw-space-y-4">
        <h1 className="tw-mb-6 tw-flex  tw-items-center tw-gap-1 tw-text-lg tw-text-grayscale-180">
          <span className="tw-font-semibold">
            {t('insightsLite.analytics')}
          </span>
          <Badge variant="gray">{t('lite')}</Badge>
          <Badge variant="primary">{t('beta')}</Badge>
        </h1>
        {activeState.page && (
          <section className="tw-grid tw-w-full">
            <InsightLitePagePerformance page={activeState.page} />
          </section>
        )}

        {activeState.page && (
          <div className="tw-shadow-s tw-space-y-8 tw-rounded tw-bg-white tw-p-4 tw-pb-2">
            <h2 className="tw-mb-6 tw-text-base tw-font-semibold tw-text-grayscale-180">
              {t('insightsLite.topPerformingPosts')}
            </h2>
            <InsightLitePostsPerformance page={activeState.page} />
          </div>
        )}
      </section>
      <section>
        <Divider className="tw-my-6" />
        <div className="tw-w-full md:tw-w-1/3">
          <RequestNewMetricsCard />
        </div>
      </section>
    </>
  );
};

export default InsightsLiteContent;
